import {ActivityLogFormItem, ActivityLogListItem, getActivityLogService} from "../../activity-log/activityLogApi";
import {useGrid} from "../../../../common";
import {getOrderListService, OrderListFormItem, OrderListItem} from "./orderListApi";


export default function useOrderList() {
  const service = getOrderListService();
  const grid = useGrid<OrderListFormItem, OrderListItem>({
    comaSeparatedSortPrarms: true,
    storageType: "urlParams",
    id: "activityLog",
    loadColumns: true,
    translationCategory: "activityLog",
    confirmAttribute: "description",
    ...service,
  });

  return {
    grid
  };
}